
export class Compare {
    constructor({
        tabContentId,
        propertyClassName,
        propertyValueClassName,
        toggleClassName,
        enabled
    }) {
        this.tabContentId = tabContentId;
        this.propertyClassName = propertyClassName;
        this.propertyValueClassName = propertyValueClassName;
        this.toggleClassName = toggleClassName;
        this.enabled = enabled;

        this.listen();
    }

    async listen() {
        const thisClass = this;
        const toggleElement = document.querySelector('.' + this.toggleClassName);

        if (toggleElement) {
            toggleElement.addEventListener('change', () => {
                thisClass.enabled = toggleElement.checked;
                thisClass.toggleValues();
            });
        }

        const tabPane = document.querySelector('#' + this.tabContentId + ' .tab-pane.active');
        if (tabPane) {
            let {getMaxHeight, updateHeight} = await import("./sameHeight");
            const propertyCount = tabPane.getAttribute('data-properties');

            for (let i = 1; i <= parseInt(propertyCount); i++) {
                const values = tabPane.querySelectorAll('.' + thisClass.propertyValueClassName + '[data-property="' + i + '"]');
                const property = tabPane.querySelectorAll('.' + thisClass.propertyClassName + '[data-property="' + i + '"]');

                let itemsMaxHeight = getMaxHeight(values);
                updateHeight(values, itemsMaxHeight);
                updateHeight(property, itemsMaxHeight);
            }
        }
    }

    toggleValues() {
        const thisClass = this;

        if (this.enabled) {
            const tabs = document.querySelectorAll('#' + this.tabContentId + ' .tab-pane');
            Array.from(tabs).forEach(function(tab) {
                const propertyCount = tab.getAttribute('data-properties');
                const productCount = tab.getAttribute('data-products');

                if (productCount > 1) {
                    for (let i = 1; i <= parseInt(propertyCount); i++) {
                        const values = tab.querySelectorAll('.' + thisClass.propertyValueClassName + '[data-property="' + i + '"]');

                        let lastValue = '';
                        let matches = 0;

                        Array.from(values).forEach(function(value, index) {
                            if (index === 0) {
                                lastValue = value.textContent;
                                matches++;
                                return true;
                            }

                            if (lastValue === value.textContent) {
                                matches++;
                            } else {
                                return false;
                            }
                        });

                        if (matches === values.length) {
                            Array.from(values).forEach(function(value) {
                                value.style.display = 'none';
                            });

                            const property = tab.querySelector('.' + thisClass.propertyClassName + '[data-property="' + i + '"]');
                            if (property) {
                                property.style.display = 'none';
                            }
                        }
                    }
                }
            });
        } else {
            const values = document.getElementsByClassName(this.propertyValueClassName);
            Array.from(values).forEach(function(value) {
                value.style.display = 'block';
            });

            const properties = document.getElementsByClassName(this.propertyClassName);
            Array.from(properties).forEach(function(property) {
                property.style.display = 'block';
            });
        }
    }
}
